const fragment = `
  id
  name
  imageUrl
  description
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
`;

export const listOptionTypesQuery = `
  query ListOptionTypes(
    $filter: OptionTypeFilterInput!
  ) {
    items: listOptionTypes(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getOptionTypeQuery = `
  query GetOptionType($id: Int!) {
    item: getOptionType(id: $id) {
      ${fragment}
    }
  }
`;

export const createOptionTypeQuery = `
  mutation CreateOptionType(
    $input: CreateOptionTypeInput!
    $image: Upload
  ) {
    item: createOptionType(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateOptionTypeQuery = `
  mutation updateOptionType(
    $input: UpdateOptionTypeInput!
    $image: Upload
  ) {
    item: updateOptionType(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteOptionTypeQuery = `
  mutation DeleteOptionType(
    $id: Int!
  ) {
    item: deleteOptionType(id: $id) {
      ${fragment}
    }
  }
`;
